"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCardExercise = void 0;
const react_1 = require("react");
const react_redux_1 = require("react-redux");
const helpers_1 = require("@app/helpers");
const exercise_js_1 = require("@app/routes/SpeechDevelopment/reducers/exercise.js");
const useIsProcessing_1 = require("@app/routes/SpeechDevelopment/hooks/useIsProcessing");
const DefaultCardsExerciseHandler_1 = require("@app/routes/SpeechDevelopment/handlers/DefaultCardsExerciseHandler");
const timer_1 = require("@app/routes/SpeechDevelopment/exersices/Disinhibition/timer");
const useCoins_1 = __importDefault(require("@hooks/useCoins"));
const useCardExercise = ({ exerciseParams }, ExerciseHandler = DefaultCardsExerciseHandler_1.DefaultCardsExerciseHandler) => {
    var _a, _b;
    const dispatch = (0, react_redux_1.useDispatch)();
    const langId = (0, helpers_1.getCurrentLanguage)();
    const answers = (0, exercise_js_1.useSelectAnswers)();
    const currentCardIndex = (0, exercise_js_1.useSelectCurrentIndex)();
    const isStarted = (0, exercise_js_1.useSelectIsStarted)();
    const [isPaused, setIsPaused] = (0, react_1.useState)(true);
    const store = (0, react_redux_1.useSelector)((store) => store);
    const _c = (0, useCoins_1.default)(), { addCoin } = _c, coinCounts = __rest(_c, ["addCoin"]);
    const { isProcessing, setIsProcessing, canLeaf } = (0, useIsProcessing_1.useIsProcessing)();
    const exHandler = new ExerciseHandler({
        store,
        dispatch,
        setIsProcessing,
        exerciseParams,
        langId,
        addCoin: () => __awaiter(void 0, void 0, void 0, function* () { return addCoin(3, 5); }),
    });
    const handleAnswer = (0, react_1.useCallback)((event) => __awaiter(void 0, void 0, void 0, function* () {
        if (isProcessing.current)
            return;
        setIsProcessing(true);
        const result = yield exHandler.handleAnswer(event);
        setIsProcessing(false);
        return result;
    }), [exHandler]);
    const handleStart = () => __awaiter(void 0, void 0, void 0, function* () {
        var _d;
        if (!isStarted) {
            dispatch((0, exercise_js_1.setIsStarted)(true));
            exHandler.initInfoRep((_d = exHandler.current) === null || _d === void 0 ? void 0 : _d.id);
        }
        setIsPaused(false);
    });
    const handlePause = () => {
        exHandler.pause();
        setIsPaused(true);
    };
    const handleNext = () => {
        exHandler.nextCard();
    };
    const handlePrev = () => {
        exHandler.previousCard();
    };
    const handleEndExercise = () => {
        exHandler.stopExercise();
    };
    (0, react_1.useEffect)(() => {
        const handleCurrentCard = () => __awaiter(void 0, void 0, void 0, function* () {
            yield exHandler.playCurrentQuestion();
            (0, timer_1.startTimer)(() => __awaiter(void 0, void 0, void 0, function* () {
                setIsProcessing(true);
                yield exHandler.handleTimerOut();
                setIsProcessing(false);
            }));
        });
        if (isStarted)
            handleCurrentCard();
    }, [currentCardIndex, isStarted]);
    const answersFrameArray = exHandler.data.map(({ id }) => ({ isCorrect: false, id }));
    answersFrameArray.splice(0, answers.length, ...answers);
    return {
        handleAnswer,
        isPaused,
        isStarted,
        canLeaf,
        handlePause,
        handleNext,
        handlePrev,
        handleEndExercise,
        handleStart,
        exHandler,
        answersFrameArray,
        currentCardIndex,
        card: Object.assign(Object.assign({}, exHandler.current), { isCorrect: (_a = answers[currentCardIndex]) === null || _a === void 0 ? void 0 : _a.isCorrect }),
        isLast: currentCardIndex === ((_b = exerciseParams === null || exerciseParams === void 0 ? void 0 : exerciseParams.text) === null || _b === void 0 ? void 0 : _b.offers.length) - 1,
        coinCounts,
    };
};
exports.useCardExercise = useCardExercise;
